import { Component, OnInit, Injectable } from '@angular/core';
import { faLinkedinIn, faTwitter, faInstagram, faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
    selector: 'fisico-header',
    templateUrl: './header.component.html',
    styleUrls: ['../fisico.component.css']
})
@Injectable()

export class FisicoHeader implements OnInit {
  linkedin = faLinkedinIn;
  facebook = faFacebookF;
  twitter = faTwitter;
  instagram = faInstagram;

  menuCollapse: boolean;
  vagaId: string;
  empresa: string;

  constructor(private actRouter: ActivatedRoute, private http: HttpClient, private router: Router){
    this.menuCollapse = false;
    this.vagaId = '';
    this.empresa = '';
  }

  ngOnInit(): void {
    this.actRouter.params.subscribe((params) => {
      //console.log("header", params);

      if (params.codigo) {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        this.http.get('https://api.reachr.com.br/api/VagaParts/CodigoVaga/' + params.codigo + '?v=' + new Date().getTime(), {headers: headers}).subscribe((data:any) => {
          //console.log(data);
          if (data.id) {
            this.vagaId = data.id
            this.empresa = data.Empresa.Caracteristica.Nome
          }
        }, (error) => {
          console.log(error);
        });
      }
    });
  }

  abrirFecharMenu() {
    if (this.menuCollapse == false) {
      this.menuCollapse = true;
      let element = document.getElementById('navbarSupportedContent');
      if (!element.classList.contains("show"))
        element.classList.add("show");
    } else {
      this.menuCollapse = false;
      let element = document.getElementById('navbarSupportedContent');
      if (element.classList.contains("show"))
        element.classList.remove("show");
    }
  }

  irParaLogin() {
    if (this.empresa == 'NEXT JOB') {
      this.router.navigate(['candidato/login'], { queryParams: { nextjobvagaid: this.vagaId } });

    } else if (this.empresa) {
      this.router.navigate(['candidato/login'], { queryParams: { vagaid: this.vagaId } });

    } else {
      this.router.navigate(['candidato/login']);

    }
  }

  irParaCadastro() {
    if (this.empresa == 'NEXT JOB') {
      this.router.navigate(['candidato/cadastrar'], { queryParams: { nextjobvagaid: this.vagaId } });

    } else if (this.empresa) {
      this.router.navigate(['candidato/cadastrar'], { queryParams: { vagaid: this.vagaId } });

    } else {
      this.router.navigate(['candidato/cadastrar']);

    }
  }
}
